// Copyright (c) 2016 Deere & Company

import './status-change-request-modal.scss';
import React, {PropTypes} from 'react';
import AdditionalStatusesList from '../../../status-change-request/components/product-info-view/additional-statuses-list';
import {FormattedMessage} from 'react-intl';
import Modal from '../../state/modal';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import ProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import ProductStatusInfo from '../product-status-info';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {WarrantyMediumModal} from '../../../../shared/components/modal';
import {hasAccess} from '../../../../shared/services/security';

function handleClick() {

    this.changeModalVisibility(false);

}

const StatusChangeRequestModal = (props, context) =>
    <section className='status-change-request-modal'>
        <WarrantyMediumModal isOpen={props.productStatusChangeModal.isVisible}>
            <header>
                <FormattedMessage
                    id='STATUS_FOR'
                    values={{
                        pin: props.product.pin
                    }}
                />
                {hasAccess(context.security, 'PRT', 'PRT_STATUS_CHANGE') &&
                <button onClick={props.updateStatus}>
                    <FormattedMessage id='CHANGE_STATUS'/>
                </button>
                }
                <span
                    className='close-modal-icon'
                    onClick={props::handleClick}
                />
            </header>
            <div className='modal-body'>
                <ProductStatusInfo status={props.product.status[0]}/>
                <AdditionalStatusesList statuses={props.product.status.slice(1)}/>
            </div>
        </WarrantyMediumModal>
    </section>;

StatusChangeRequestModal.displayName = 'StatusChangeRequestModal';
StatusChangeRequestModal.propTypes = {
    changeModalVisibility: PropTypes.func.isRequired,
    product: PropTypes.oneOfType([
        PropTypes.instanceOf(Product),
        PropTypes.instanceOf(ProductSearchResult)
    ]).isRequired,
    productStatusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    updateStatus: PropTypes.func.isRequired
};
StatusChangeRequestModal.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

StatusChangeRequestModal.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default StatusChangeRequestModal;



// WEBPACK FOOTER //
// ./src/product/shared/components/status-change-request-modal/status-change-request-modal.js